import { useMemo } from 'react'
import { Navigate, Outlet, useMatch } from 'react-router'
import { generateDynamicSeasons } from '@/utils/season'

export function RequireSeasonGuard() {
  const exactMatch = useMatch('/:season')
  const deepMatch = useMatch('/:season/*')
  const season = (deepMatch ?? exactMatch)?.params?.season

  const validSeasons = useMemo(
    () => generateDynamicSeasons().map(s => s.season.replace(/\s+/g, '')),
    [],
  )

  if ((exactMatch || deepMatch) && (!season || !validSeasons.includes(season))) {
    return <Navigate to="/" replace />
  }

  return <Outlet />
}
